/** @jsx jsx */
import React from 'react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import Image from '@atlaskit/image';
import { cssMap, jsx } from '@atlaskit/css';
import type { image_reportsOverviewPage_ReportCardImage$key } from '@atlassian/jira-relay/src/__generated__/image_reportsOverviewPage_ReportCardImage.graphql';
import { IMAGE_WIDTH, IMAGE_HEIGHT } from '../../common/constants.tsx';
import { getImageForKey } from '../report-image/utils.tsx';

export const ReportCardImage = ({
	report,
}: {
	report: image_reportsOverviewPage_ReportCardImage$key;
}): JSX.Element => {
	const reportData = useFragment<image_reportsOverviewPage_ReportCardImage$key>(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment image_reportsOverviewPage_ReportCardImage on JiraReport {
				key @required(action: THROW)
				name @required(action: THROW)
				isNotApplicableReason @include(if: $isMigrateTMPReportsOverviewEnabled)
				imageUrl
			}
		`,
		report,
	);

	const key = reportData.key;
	const name = reportData.name;
	const url = reportData.imageUrl;
	const isNotApplicableReason = reportData.isNotApplicableReason;

	if (url) {
		return (
			<div css={[styles.image, isNotApplicableReason && styles.imageDisabled]}>
				<Image src={url} width={IMAGE_WIDTH} height={IMAGE_HEIGHT} alt={name} />
			</div>
		);
	}
	return <div css={styles.image}>{getImageForKey(key, name)}</div>;
};

const styles = cssMap({
	image: {
		height: '144px',
		overflow: 'hidden',
	},
	imageDisabled: {
		filter: 'grayscale(100%)',
	},
});
